import { useQueryClient } from "@tanstack/react-query";

import { usersKeys } from "./query_keys";

export const useUserImportsInvalidate = () => {
  const cache = useQueryClient();

  return {
    invalidate: () => cache.invalidateQueries({ queryKey: usersKeys.imports() })
  };
};
